import React from 'react';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { toggleModal } from '../../../reducers/modalReducer';

const FA_INFO_CONFIG = {
    'unallocated-bin': {
        subtitle: 'Unallocated Bin',
        actionLabel: 'Take me to the bin',
        steps: [require(`../../../../images/filing-assistant-popup/unallocated-bin-step-1.png`), require(`../../../../images/filing-assistant-popup/unallocated-bin-step-2.png`), require(`../../../../images/filing-assistant-popup/unallocated-bin-step-3.png`)],
    },
    'filing-assistant': {
        subtitle: 'Filing Assistant Manager',
        actionLabel: 'Run filing assistant',
        steps: [require(`../../../../images/filing-assistant-popup/filing-assistant-step-1.png`), require(`../../../../images/filing-assistant-popup/filing-assistant-step-2.png`), require(`../../../../images/filing-assistant-popup/filing-assistant-step-3.png`)],
    },
    'deduper': {
        subtitle: 'Deduper',
        actionLabel: 'View Deduper',
        steps: [require(`../../../../images/filing-assistant-popup/deduper-step-1.png`), require(`../../../../images/filing-assistant-popup/deduper-step-2.png`), require(`../../../../images/filing-assistant-popup/deduper-step-3.png`)],
    },
    'deduper-reports': {
        subtitle: 'Deduper Reports',
        actionLabel: 'View Report',
        steps: [require(`../../../../images/filing-assistant-popup/deduper-reports-step-1.png`), require(`../../../../images/filing-assistant-popup/deduper-reports-step-2.png`), require(`../../../../images/filing-assistant-popup/deduper-reports-step-3.png`)],
    },
};

export default function FilingAssistantInfoModal({ onAction }) {
    const dispatch = useDispatch();
    const modal = useSelector(state => state.modal);

    const isOpen = modal['open'] === 'filingAssistantInfo';
    const key = modal['faInfoKey'];
    const config = FA_INFO_CONFIG[key];

    const close = () => dispatch(toggleModal({ open: '' }));
    const handleAction = () => { if (onAction && key) onAction(key); close(); };

    if (!isOpen || !config) return null;

    return (
        <Modal open={isOpen} onClose={close} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df aic jcc">
            <div className="bg20 shadow bsbb br20px p4rem maw1200px w100 mx1rem hideScrollbar mah80 oya" style={{ outline: 'none' }}>
                <h1 className="c15 fs2rem fw500 tac">What is it?</h1>
                <h2 className="c3 fs1-25rem fw500 tac mb1-5rem">{config['subtitle']}</h2>
                <div className="df aic jcc w80 mla mra mb1-5rem"><img src={require(`../../../../images/filing-assistant-popup/three-steps.png`)} alt='steps' /></div>
                {/* Step cards */}
                <div className="df jcc mb2rem">
                    {config['steps'].map((step, i) => <img src={step} alt={`step=${i}`} className='mx1rem' />)}
                </div>

                {/* Footer */}
                <div className="df aic jcsb px4rem">
                    <button onClick={close} className="cp df aic c15 fw500 fs1rem bg44"><span className="mr0-5rem fs1-25rem">←</span> Back</button>
                    <button onClick={handleAction} className="cp shadow c1 fw500 fs1rem br50px px2-5rem py0-75rem bg4 bg3-hover">{config['actionLabel']}</button>
                </div>
            </div>
        </Modal>
    );
}
